export default "__VITE_ASSET__706177a2__"